// import { useEffect } from "react";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { getPageBackgroundGradient } from "../../../config/theme";

interface FirstTimeLoadingProps {
    isDark: boolean;
    t: any;
}

export function FirstTimeLoading({ isDark, t }: FirstTimeLoadingProps) {
    // useEffect(() => {
    //     const audio = new Audio('/audios/loading_chime.mp3');
    //     audio.volume = 0.5;
    //     audio.play().catch(e => console.warn('Failed to play loading sound:', e));

    //     return () => {
    //         audio.pause();
    //         audio.currentTime = 0;
    //     };
    // }, []);

    return (
        <div className="fixed inset-0 z-[2000] flex flex-col items-center justify-center">
            <div className={`absolute inset-0 bg-gradient-to-b ${getPageBackgroundGradient(isDark ? 'dark' : 'light')}`} />

            <motion.div
                className="absolute top-1/4 right-1/4"
                animate={{ opacity: [0.4, 1, 0.4], scale: [0.8, 1.2, 0.8] }}
                transition={{ duration: 2, repeat: Infinity }}
            >
                <Sparkles className="w-8 h-8 text-yellow-200" fill="currentColor" />
            </motion.div>

            <motion.div
                className="absolute bottom-1/4 left-1/4"
                animate={{ opacity: [0.3, 0.8, 0.3], scale: [0.9, 1.1, 0.9] }}
                transition={{ duration: 3, repeat: Infinity, delay: 1 }}
            >
                <Sparkles className="w-6 h-6 text-yellow-100" fill="currentColor" />
            </motion.div>

            <div className="relative z-10 flex flex-col items-center gap-8">
                <h2 className={`text-xl font-medium bg-clip-text text-transparent bg-gradient-to-r ${isDark ? 'from-white via-blue-100 to-white/80' : 'from-gray-800 via-blue-600 to-gray-800'}`}>
                    {t('whisper.loading.firstTime')}
                </h2>

                <div className="relative w-16 h-16">
                    <motion.div
                        className={`absolute inset-0 border-4 rounded-full border-transparent ${isDark ? 'border-t-yellow-200 border-r-yellow-200/30' : 'border-t-blue-500 border-r-blue-500/30'}`}
                        animate={{ rotate: 360 }}
                        transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
                    />

                    <motion.div
                        className={`absolute inset-3 border-4 rounded-full border-transparent ${isDark ? 'border-b-blue-300 border-l-blue-300/30' : 'border-b-indigo-400 border-l-indigo-400/30'}`}
                        animate={{ rotate: -360 }}
                        transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
                    />
                </div>
            </div>
        </div>
    );
}
